import * as React from 'react';

import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import AddButton from 'components/AddButton';
import ModalTrigger from 'components/ModalTrigger';
import Group from 'entities/Group';
import JoinGroupModal from 'groups/components/JoinGroupModal';
// @ts-ignore
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';

type Props = {
  router: InjectedRouter;
};

function NavigationListJoinGroupAction(props: Props) {
  const handleGroupJoined = (group: Group) => {
    props.router.push(getRedirectLocationAfterGroupJoin(group));
  };

  return (
    <ModalTrigger modal={<JoinGroupModal onJoin={handleGroupJoined} onRequestHide={() => {}} />}>
      <AddButton
        weight="semibold"
        className="NavigationListDeprecated-section-header"
        data-test-selector="join_class_nav_link"
        eventElementName="NavigationList-join-class">
        Join a class
      </AddButton>
    </ModalTrigger>
  );
}

export { NavigationListJoinGroupAction };
export default withRouter(NavigationListJoinGroupAction);
